module.exports = __webpack_public_path__ + "img/loader.8d38c9f1.svg";